/*eslint no-undef: 0*/

/**
 * Scroll to the top of the element after ajax call is completed
 */
// eslint-disable-next-line no-unused-vars
const scrollTopAfterAjax = (target, flag) => {
  const $page = $('html, body');

  $page.animate({
    scrollTop: target.offset().top - document.getElementById('masthead').clientHeight - 1,
  }, {
    duration: 750, easing: 'easeInOutQuint', complete: function () {
      flag = false;
    },
  });
};


export default scrollTopAfterAjax;



// WEBPACK FOOTER //
// ./scripts/util/scroll-top-ajax.js